import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import Spinner from "../Spinner/Spinner";

import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const EmptyState = (props) => {

    const intl = useIntl();
    let text = props.text != null? props.text : intl.messages.stateNoItem;

    return (
        <div className="state state-smoke py-3">
            <span className="state-icon disabled">
                {props.progress ? <Spinner /> : 
                    <FontAwesomeIcon icon={props.icon}/>
                }
            </span>
            <span><h4>{text}</h4></span>
            { props.desc && <span className="px-3"><h5>{props.desc}</h5></span> }
            
        </div>
    );
}

EmptyState.defaultProps = {
    icon: faInfo,
    text: null,
    desc: "",
    progress: false
}

EmptyState.propTypes = {
    text: PropTypes.string,
    icon: PropTypes.object,
    desc: PropTypes.string,
    progress: PropTypes.bool
};

export default EmptyState;